import { render, staticRenderFns } from "./BadgeCreatorWidget.vue?vue&type=template&id=56b92ce2&scoped=true"
import script from "./BadgeCreatorWidget.vue?vue&type=script&lang=js"
export * from "./BadgeCreatorWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b92ce2",
  null
  
)

export default component.exports